/**
 * Slug e imagen de un animal.
 *
 * Estaba duplicado entre el catálogo y la ficha. `slugify` y `buildAnimalSlug`
 * ARMAN URLS: si las dos copias divergen, el catálogo linkea a una dirección y
 * la ficha construye otra para el mismo animal — links rotos justo en la
 * pantalla desde la que la gente comparte por WhatsApp.
 *
 * La cascada de imagen estaba TRES veces: una en la ficha y dos dentro del
 * catálogo (la tarjeta y el destacado).
 */
import { fixUrl } from '../services/api';

export const slugify = (text) =>
  String(text)
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .trim();

export const buildAnimalSlug = (animal) => `${animal.id_animal}-${slugify(animal.nom_animal)}`;

export const youtubeThumb = (url) => {
  if (!url) return null;
  const m = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
  return m ? `https://img.youtube.com/vi/${m[1]}/hqdefault.jpg` : null;
};

/**
 * Imagen del animal con cascada: foto principal → thumb del video → fallback
 * del evento.
 *
 * `fallback_reemplaza_video` invierte los dos últimos: hay productores que
 * prefieren su placeholder antes que la miniatura de YouTube, que muchas veces
 * es un cuadro negro del arranque del video.
 */
export const imagenAnimalUrl = (a, config) => {
  const foto = fixUrl(a?.imagen_portada?.url_thumb || a?.imagen_portada?.url_imagen);
  const yt = youtubeThumb(a?.codigo_video);
  const fb = config?.imagen_fallback_animal ? fixUrl(config.imagen_fallback_animal) : null;
  return config?.fallback_reemplaza_video ? (foto || fb || yt) : (foto || yt || fb);
};
